import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API = `${BACKEND_URL}/api`;
const GOOGLE_APPS_SCRIPT_URL = process.env.REACT_APP_GOOGLE_APPS_SCRIPT_URL || 'https://script.google.com/macros/s/AKfycby2ZKPeaeuM33JuDylbFCKh5U-4jxqsklceJbGBAqpRzw6w2kBDxTi-fel-MJnkYwBn2A/exec';

export const getPlans = async (category = null, type = null) => {
  try {
    let url = `${API}/plans`;
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (type) params.append('type', type);
    if (params.toString()) url += `?${params.toString()}`;
    
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching plans:', error);
    throw error;
  }
};

export const submitContactForm = async (formData) => {
  try {
    const response = await axios.post(`${API}/contact`, formData);
    return response.data;
  } catch (error) {
    console.error('Error submitting contact form:', error);
    throw error;
  }
};

/**
 * Submits an NRI Callback lead to the server.
 * If server is offline or unreachable, securely stores locally to prevent lead loss.
 */
export const submitNRICallbackLead = async (leadData) => {
  try {
    const response = await axios.post(`${API}/leads/callback`, leadData);
    return response.data;
  } catch (error) {
    console.warn('Backend API submission error, attempting direct Google Sheets fallback:', error.message);

    // Direct fallback to Google Apps Script Web App
    if (GOOGLE_APPS_SCRIPT_URL) {
      try {
        const leadId = `VSR-NRI-${new Date().toISOString().slice(0, 10).replace(/-/g, '')}-${Math.random().toString(36).substring(2, 6).toUpperCase()}`;
        const payload = {
          lead_id: leadId,
          timestamp_utc: new Date().toISOString(),
          data: leadData
        };
        await fetch(GOOGLE_APPS_SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        return {
          success: true,
          lead_id: leadId,
          message: 'Thank you! Your callback request has been received. Advisor V. S. Reddy will contact you shortly.'
        };
      } catch (scriptErr) {
        console.warn('Apps Script direct submission failed, falling back to local storage:', scriptErr);
      }
    }
    
    // Save to localStorage as final safeguard so lead is never lost
    try {
      const localLeads = JSON.parse(localStorage.getItem('vsr_nri_leads') || '[]');
      const offlineId = `VSR-NRI-OFFLINE-${Date.now()}`;
      localLeads.push({
        ...leadData,
        lead_id: offlineId,
        date: new Date().toISOString()
      });
      localStorage.setItem('vsr_nri_leads', JSON.stringify(localLeads));
      return {
        success: true,
        offline: true,
        lead_id: offlineId,
        message: 'Thank you! Your request has been received. VSR Insurance Plus will contact you using the details provided.'
      };
    } catch (storageErr) {
      console.error('Local backup storage error:', storageErr);
      throw error;
    }
  }
};
